import apiService from '../../../services/api-client';
import { DeleteContainerResponse } from '../interfaces/delete-container';
import { GetContainerProductsResponse } from '../interfaces/get-container-products';
import { GetContainersParams, GetContainersResponse } from '../interfaces/get-containers';
import {
  PostContainerPayloadRequest,
  PostContainerResponse,
} from '../interfaces/post-container';
import { PostLightContainerPayloadRequest, PostLightContainerResponse } from '../interfaces/post-light-container';
import { PostProductToContainerPayloadRequest, PostProductToContainerResponse } from '../interfaces/post-product-to-container';
import {
  PutContainerPayloadRequest,
  PutContainerResponse,
} from '../interfaces/put-container';

export const containersApiService = {
  async getContainers(id: number, params: GetContainersParams) {
    // Convertir los parámetros para el backend
    const queryParams: any = { ...params };
    
    // Si priceRange es "sin-rango", enviarlo como string
    if (params.priceRange === 'sin-rango') {
      queryParams.price_range_id = 'sin-rango';
      delete queryParams.priceRange;
    } else if (params.priceRange !== undefined) {
      queryParams.price_range_id = params.priceRange;
      delete queryParams.priceRange;
    }
    
    // Mapear recipientType a recipientType
    if (params.recipientType !== undefined) {
      queryParams.recipientType = params.recipientType;
    }
    
    const { data } = await apiService().get<GetContainersResponse>(
      `company/${id}/containers`, { params: queryParams }
    );
    return data;
  },
  async getContainerProducts(cId: number, tId: number) {
    const { data } = await apiService().get<GetContainerProductsResponse>(
      `company/${cId}/container/${tId}/products`,
    );
    return data;
  },
  async postContainer(id: number, body: PostContainerPayloadRequest) {
    const { data } = await apiService().post<PostContainerResponse>(
      `company/${id}/container`,
      body
    );
    return data;
  },
  async postLightContainer(id: number, body: PostLightContainerPayloadRequest) {
    const { data } = await apiService().post<PostLightContainerResponse>(
      `company/${id}/container/lightweight`,
      body
    );
    return data;
  },
  async postProductToContainer(cId: number, tId: number, body: PostProductToContainerPayloadRequest) {
    const { data } = await apiService().post<PostProductToContainerResponse>(
      `company/${cId}/container/${tId}/product`,
      body
    );
    return data;
  },
  async postProductToLocation(cId: number, tId: number, body: PostProductToContainerPayloadRequest) {
    const { data } = await apiService().post<PostProductToContainerResponse>(
      `company/${cId}/location/${tId}/product`,
      body
    );
    return data;
  },
  async postContainerFile(cId: number, containerId: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await apiService().post(`company/${cId}/container/${containerId}/file`, formData);
    return data;
  },
  async deleteContainerFile(cId: number, containerId: number, fileId: number) {
    const { data } = await apiService().delete(
      `company/${cId}/container/${containerId}/file/${fileId}`
    );
    return data;
  },
  async putContainer(
    cId: number,
    pId: number,
    body: PutContainerPayloadRequest
  ) {
    const { data } = await apiService().put<PutContainerResponse>(
      `company/${cId}/container/${pId}`,
      body
    );
    return data;
  },
  async deleteContainer(cId: number, pId: number) {
    const { data } = await apiService().delete<DeleteContainerResponse>(
      `company/${cId}/container/${pId}`
    );
    return data;
  },
  async patchContainerLocation(
    cId: number,
    tId: number,
    lId: number,
  ) {
    const { data } = await apiService().patch(`company/${cId}/container/${tId}/location/${lId}`, {});
    return data;
  },
  async getContainerAuditReport(companyId: number, containerId: number) {
    const { data } = await apiService().get<{ movements: any[] }>(
      `company/${companyId}/container/${containerId}/report`
    );
    return data;
  },
};